export class Integration {
	windowMessage(data){
		// console.log("message out", JSON.stringify(data));
		if(window.location.hostname !== 'localhost'){
			window.parent.postMessage(JSON.stringify(data), '*');
		}
	}

	parseBetSizes(){
		console.warn(`"parseBetSizes" not implemented`);
	}

	login(){
		console.warn(`"login" not implemented`);
	}

	initAnalytics(uid) {

	}

	postAnalyticsEvent(id, label, value, category) {
		// if(process.env.NODE_ENV === 'development' && window.location.hash !== '#sendanalytics'){
		// 	return;
		// }
		// var data = {};
		// data.event_label = label;
		// data.event_category = category || store.tutorialMode ? 'tutorial' : 'gameplay';
		// data.value = typeof value === 'number' ? value : 0;
		// console.log('gtag: ', id, data);
		// window.gtag('event', id, data);
	}

	onLoad(call){
		console.warn(`"onLoad" not implemented`);
	}
	onMatchStart(call){
		console.warn(`"onMatchStart" not implemented`);
	}
	onMatchResult(call){
		console.warn(`"onMatchResult" not implemented`);
	}
	onMatchEnd(call){
		console.warn(`"onMatchEnd" not implemented`);
	}
	onLowBalance(call){
		console.warn(`"onLowBalance" not implemented`);
	}
	onBetScreenReturn(){
		console.warn(`"onBetScreenReturn" not implemented`);
	}
	onError(call){
		console.warn(`"onError" not implemented`);
	}
	onShowFinalScorecard(call){
		console.warn(`"onShowFinalScorecard" not implemented`);
	}
	onTutorialOpen(call){
		console.warn(`"onTutorialOpen" not implemented`);
	}
	onTutorialStart(call){
		console.warn(`"onTutorialStart" not implemented`);
	}
	onTutorialAborted(call){
		console.warn(`"onTutorialAborted" not implemented`);
	}
	onTutorialSkipped(call){
		console.warn(`"onTutorialSkipped" not implemented`);
	}
	onTutorialCompleted(call){
		console.warn(`"onTutorialCompleted" not implemented`);
	}
}